import * as Spring from "react-spring";

export function enter(isOpen: boolean) {
	return Spring.useSpring({
		from: { transform: "translateX(100%)" },
		to: { transform: isOpen ? "translateX(0%)" : "translateX(100%)" },
	});
}
